/* global window */

export function newRequest() {
  return new window.XMLHttpRequest();
}
